import { Outlet } from 'react-router-dom';
import Header from '@layout/header/Header';
import Footer from '@layout/footer/Footer';
import SideElement from '@layout/side-element/SideElement';



const Layout = (): JSX.Element => {

	return (
		<>
			<div className="app-layout">

				<Header />
				
				<Outlet />

				<Footer />

			</div>

			<SideElement />
		</>
	);
};

export default Layout;